import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NavBar from '../NavBar';
import { setTitle } from '../../native';
import parse from '../../util-lib/ua';


const UA = window.navigator.userAgent;
const HEIGHT = document.documentElement.offsetHeight;

const browser = parse(UA).browser;
function showNavBar() {
  return [
    'zuzuche',
    'tantutravel',
    'tantumap',
    'WechatMiniprogram',
    'blackcard',
    'WeChat',
    'crc'
  ].indexOf(browser.name) === -1;
}

/**
 * 页面组件。满屏，内部滚动
 * 注意：依赖HTML高度
 */
export default class PageFullScreen extends React.Component {
  static propTypes = {
    defaultNavBar: PropTypes.bool,
    defaultNavBarProps: PropTypes.shape({
      // ...NavBar.propTypes
      title: PropTypes.string
    }),
    navBar: PropTypes.node,
    children: PropTypes.node.isRequired,
    // eslint-disable-next-line
    style: PropTypes.object,
    isShowNavBar: PropTypes.bool
  };

  static defaultProps = {
    defaultNavBar: true,
    defaultNavBarProps: {},
    navBar: null,
    style: {}
  };

  componentDidMount() {
    this.setTitle();
  }

  componentDidUpdate(prevProps) {
    const { defaultNavBarProps } = this.props;
    const { title } = defaultNavBarProps;

    if (title !== prevProps.defaultNavBarProps.title) {
      this.setTitle();
    }
  }

  setTitle() {
    const { defaultNavBarProps } = this.props;
    const { title } = defaultNavBarProps;
    if (!title) return;
    document.title = title;
    setTitle(title);
  }


  render() {
    const {
      children, style, className,
      navBar, defaultNavBar, defaultNavBarProps, isShowNavBar = true, ...rest
    } = this.props;

    let targetNavBar = navBar;
    if (!targetNavBar && defaultNavBar) {
      targetNavBar = (<NavBar {...defaultNavBarProps} />);
    }

    const cls = classnames('component-page component-page-full-screen', className);

    return (
      <main
        {...rest}
        className={cls}
        style={{
          height: HEIGHT,
          ...style
        }}
      >
        {isShowNavBar && targetNavBar && showNavBar() && (
          <div className="component-page-full-screen-header">
            {targetNavBar}
          </div>
        )}
        <div className="component-page-full-screen-body">
          {children}
        </div>
      </main>
    );
  }
}
